const map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		52364,
		[
			2528,
			1284,
			8895,
			2364
		]
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		63409,
		[
			9690,
			2528,
			8895,
			3409
		]
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		895,
		[
			2528,
			1284,
			8895,
			5981,
			895
		]
	],
	"./shared/benchmarks/config/index.js": [
		59214,
		[
			1284,
			9214
		]
	],
	"./shared/benchmarks/hooks/index.js": [
		72580,
		[
			2580
		]
	],
	"./shared/benchmarks/screens/index.js": [
		13665,
		[
			1284,
			3665
		]
	],
	"./shared/benchmarks/simple-store/index.js": [
		88558,
		[
			8558
		]
	],
	"./shared/copy-to-clipboard/index.js": [
		17997,
		[
			8895,
			7997
		]
	],
	"./views/index.js": [
		68981,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86864;
module.exports = webpackAsyncContext;